const DURATION_RE = /^(\d+)([smhd])$/;
const UNIT_MS: Record<string, number> = { s: 1_000, m: 60_000, h: 3_600_000, d: 86_400_000 };

/** Parse a human duration ("30s", "10m", "2h", "7d") into milliseconds. Throws on anything else. */
export function parseDuration(input: string): number {
  const match = DURATION_RE.exec(input.trim());
  const value = Number(match?.[1] ?? 0);
  const unit = match?.[2];
  const unitMs = unit ? UNIT_MS[unit] : undefined;
  if (!unitMs || value <= 0) {
    throw new Error(`Invalid duration '${input}' — use <number><unit> with unit s/m/h/d (e.g. 10m, 2h, 30d)`);
  }
  return value * unitMs;
}
